<template>
  <div class="file-cloud-dialog dialog col-block width-full">
    <div class="file-cloud-title-container row-block">
      <div class="file-cloud-title">{{ $t('DIALOG.fileCloud.___title') }}</div>
      <div :style="{ width: '20px' }"></div>
      <div class="file-cloud-sub-title">{{ '(' + $t('DIALOG.fileCloud.___subtitle') + ')' }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="tree-list-container resize-container vertical">
      <textarea :style="{ height: '480px' }"></textarea>
      <div class="tree-list-block">
        <treeList
          :treeData="fileTrees"
          :options="options"
          :icons="{
            file: require('../../assets/treeIcons/tree-file.svg'),
            select: require('../../assets/treeIcons/tree-file-select.svg'),
            open: require('../../assets/treeIcons/tree-folder-open.svg'),
            close: require('../../assets/treeIcons/tree-folder-close.svg'),
            boxtrue: require('../../assets/treeIcons/checkbox-true.svg'),
            boxfalse: require('../../assets/treeIcons/checkbox-false.svg')
          }"
          :currentPath="currentPath"
          :disabledPaths="disabledPaths"
          :selectedPaths="selectedPaths"
          @select="path => pathOnSelect(path)"
        ></treeList>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :disabled="!selectedPaths.length" @click="e => selectedPaths.length ? $emit('changeModal', {}, selectedPaths) : ''">
        <span>{{ $t('COMMON.button.___select') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedPaths: []
    }
  },
  computed: {
    fileTrees () {
      let paths = this.paths.filter(path => path.endsWith('/') || !this.fileTypes.length || this.fileTypes.some(t => path.endsWith('.' + t)))
      let fileTrees = {}
      for (let path of paths) {
        let current = fileTrees
        let pathAry = path.replace(/\//g, '/ゐ').split(/ゐ/g).filter(x => x)
        for (let file of pathAry) {
          let fileName = file.replace(/\/$/, '')
          let type = file.endsWith('/') ? 'folder' : 'file'
          !current.nodes && (current.nodes = {})
          !current.nodes[fileName] && (current.nodes[fileName] = {
            type: type,
            path: pathAry.slice(0, pathAry.indexOf(file) + 1).join('').replace(/\/$/, '')
          })
          current = current.nodes[fileName]
        }
      }
      return fileTrees
    },
    // param
    type () {
      return this.param.type || 'single'
    },
    options () {
      return this.param.options || {}
    },
    fileTypes () {
      return this.param.fileTypes || []
    },
    paths () {
      return this.param.paths || []
    },
    currentPath () {
      return this.param.currentPath || ''
    },
    disabledPaths () {
      return this.param.disabledPaths || []
    },
    functions () {
      return this.param.functions || {}
    }
  },
  watch: {
    'param.defaultSelectedPaths' () {
      this.selectedPaths = [...this.param.defaultSelectedPaths]
    }
  },
  created () {
    this.selectedPaths = [...this.param.defaultSelectedPaths]
  },
  methods: {
    pathOnSelect (path) {
      let selectedPaths = this.selectedPaths.includes(path) || this.type === 'multiple' ? [...this.selectedPaths] : []
      selectedPaths.includes(path) ? selectedPaths.splice(selectedPaths.indexOf(path), 1) : selectedPaths.push(path)
      this.selectedPaths = selectedPaths
      this.functions.saveCurrentPath(path)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .treeDataViewer-main-container
    margin: 20px
    .content-container
      display: flex
      justify-content: center
      align-items: center
      .content-title
</style>



// WEBPACK FOOTER //
// src/components/dialog/fileCloud.vue